import Card from "@rio-cloud/rio-uikit/Card";

interface Props {
  label: string;
  value: string;
  icon: string;
  direction: "LEFT" | "RIGHT";
}

const Hightlight = ({ label, value, icon, direction }: Props) => {
  return (
    <Card
      className={`flex-1-1 display-flex align-items-center gap-20 padding-20 ${direction === "RIGHT" ? "align-self-end flex-row-reverse" : ""}`}
    >
      <div>
        <span className={`${icon} text-size-h1`} />
      </div>
      <div className="display-flex flex-column gap-4">
        <span
          className={`text-color-map-marker-asset text-normal text-size-14 ${direction === "RIGHT" ? "align-self-end" : ""}`}
        >
          {label}
        </span>
        <span className="text-color-map-marker-asset text-medium text-size-h3">{value}</span>
      </div>
    </Card>
  );
};

export default Hightlight;
